import Translate from '../../filters/translate'

export default {
  name: 'Notice',
  mixins: [],
  props: {},
  components: {},
  data () {
    return {}
  },

  mounted () { },

  computed: {
    text () {
      const value = document.cookie.match('(^|;) ?notice=([^;]*)(;|$)')
      if (value) {
        try {
          const notice = JSON.parse(value[2])
          let template = Translate.translate('headerNoticeTemplate')
          return template
            .replace('{{name}}', notice.name)
            .replace('{{medium}}', notice.medium)
            .replace('{{voucher}}', notice.voucher)
            .replace('{{validto}}', notice.validto)
        } catch (e) {
          console.log(e)
        }
      }
      return Translate.translate('headerNotice')
    }
  },

  methods: {}
}



// WEBPACK FOOTER //
// ./src/components/notice/script.js